module.exports = __webpack_public_path__ + "public/images/program/program-18.03eb31194007da90e87b05e1a69875e9.jpeg";